import ServerBase from '@/sdk/server/server_base';
import {ServerConfig} from '@/config/routers';
import {accountServerObj} from './account_server';

class BaikeServer extends ServerBase {
    serverUrl: string = ServerConfig.ku;

    constructor() {
        super('wikiToken');
    }

    // 企业百科人员sug接口
    async personSuggest(query: string) {
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/baike/contribute/v1/personSuggest`,
                    data: {query},
                    wikiToken: accountServerObj?.user?.token,
                }
            )
        );
        return result;
    }

    // 企业百科服务号sug接口
    async serviceStoreSuggest(query: string) {
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/baike/contribute/v1/serviceStoreSuggest`,
                    data: {query},
                    wikiToken: accountServerObj.user?.token,
                }
            )
        );
        return result;
    }

    // 词条标题名校验重复接口
    async checkEntryIsRepeat(entryName: string) {
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/baike/contribute/v1/checkEntryIsRepeat`,
                    data: {entryName},
                    wikiToken: accountServerObj.user?.token,
                }
            )
        );
        return result;
    }

    // 词条录入提交接口
    async entryInfoCommit(params?: any) {
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.ku}/baike/contribute/v1/entryInfoCommit`,
                    data: params,
                    wikiToken: accountServerObj.user?.token,
                }
            )
        );
        return result;
    }

    // 上传缩略图
    async attachOpenUpload(file?: any) {
        const formData = new FormData();
        formData.append('name', file.name);
        formData.append('file', file);
        const result = await this.request(
            Object.assign(
                {
                    method: 'post',
                    url: `${ServerConfig.baikeUpload}/attach/open/upload`,
                    data: formData,
                    wikiToken: accountServerObj.user?.token,
                    headers: {
                        'content-type': 'multipart/form-data',
                    },
                }
            )
        );
        return result;
    }

    // 获取企业百科首页Banner图列表
    async getHomepageBanner() {
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/baike/homepage/v1/banner`,
                }
            )
        );
        return result;
    }

    // 获取企业百科首页主题分类信息
    async getHomepageClassify() {
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/baike/index/classify`,
                    wikiToken: accountServerObj.user?.token,
                }
            )
        );
        return result;
    }

    // 获取企业百科首页推荐词条列表
    async getHomepageRecommendedEntry() {
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/baike/homepage/v1/recommendedEntry`,
                }
            )
        );
        return result;
    }

    // 获取企业百科首页词条页面的阅读数和收藏数
    async getHomepageViewAndFollow(params?: any) {
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/doc/info/viewAndFollow`,
                    params,
                    wikiToken: accountServerObj.user?.token,
                }
            )
        );
        return result;
    }

    // 获取企业百科首页UGC排行
    async getHomepageUgcRanking() {
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/baike/homepage/v1/ugcRanking`,
                }
            )
        );
        return result;
    }

    // 获取企业百科首页排行
    async getHomepagePGCRanking() {
        const result = await this.request(
            Object.assign(
                {
                    method: 'get',
                    url: `${ServerConfig.ku}/baike/index/pgc`,
                    wikiToken: accountServerObj.user?.token,
                }
            )
        );
        return result;
    }
}

export default BaikeServer;
